<template lang="pug">
#CambiarAFacturaAbono
  b-button(
    variant="action"
    @click="openModal"
    :disabled="disabled"
  )
    | Cambiar a Factura Abono
  ModalCambiarBoletaAFactura(
    :showModal="showModal"
    :pago="pagoAbono"
    :ov="dataOv"
    @close="showModal = false"
    @cambiado="onCambiado"
  )
</template>

<script>
import ModalCambiarBoletaAFactura from '../../ModalCambiarBoletaAFactura.vue'

export default {
  name: 'CambiarAFacturaAbono',
  components: {
    ModalCambiarBoletaAFactura,
  },
  props: {
    dataOv: {
      type: Object,
      required: true,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showModal: false,
    }
  },
  computed: {
    pagoAbono() {
      const docs = this.dataOv?.documentos_pago || []
      // El elegible según el back (puede haber un abono anterior ya cambiado)
      const found =
        docs.find(
          (p) => p.tipo_pago === 'ABONO' && p.puede_cambiar_a_factura
        ) || docs.find((p) => p.tipo_pago === 'ABONO')
      if (found) return found

      return {
        id: null,
        tipo_pago: 'ABONO',
        tipo_documento: 'boleta',
        numero_documento: this.dataOv?.nro_boleta_abono,
        monto: this.dataOv?.monto_abonado,
        created_at: this.dataOv?.created_at,
      }
    },
  },
  methods: {
    openModal() {
      this.showModal = true
    },
    onCambiado() {
      this.showModal = false
      this.$emit('reloadAll')
    },
  },
}
</script>

<style lang="scss" scoped>
@import url('../Styles/Index.scss');

#CambiarAFacturaAbono {
  width: 100%;
  text-align: center;

  ::v-deep .btn {
    width: 100%;
    justify-content: center;
    text-align: center;
  }
}
</style>
